import { track } from './segment';

export type AcknowledgeLeaseTermsErrorLike = { __typename?: string; message?: string };

// Pure builder so the payload shape can be unit-tested independently of XState.
// The GraphQL union is AppNotFound | BadRequest | FatalError | UnauthorizedError, so the
// __typename is the useful triage signal; the message is free text from the backend.
export const buildAcknowledgeFailedPayload = (errors: ReadonlyArray<AcknowledgeLeaseTermsErrorLike> | undefined) => ({
  reason: errors?.map((e) => e.__typename ?? 'unknown').join(',') || 'unknown',
});

/**
 * OR-2774: acknowledge had no failure event, so a customer who clicked Acknowledge and got an
 * error was indistinguishable in Segment from one who never clicked. Mirrors 'Signing Error',
 * which already exists on the signing side.
 */
export const trackContractSummaryAcknowledgeFailed = (context: any, event: any) => {
  const payload = buildAcknowledgeFailedPayload(event?.data?.acknowledgeLeaseTermsErrors);
  return track('Contract Summary Acknowledge Failed', payload)(context, event);
};
